import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';

/**
 * The list of tabs on this page
 */
export enum AdmissionsOverviewPageTabId {
	Overview = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum AdmissionsOverviewPageViewId {
	Overview = 1,
}


@Injectable({ providedIn: 'root' })
export class AdmissionsOverviewService extends PageTabsLayoutPageService<AdmissionsOverviewPageTabId, AdmissionsOverviewPageViewId> {
	private static readonly _viewDroplistItems: DroplistItem<never, AdmissionsOverviewPageViewId>[] = [
		{
			uniqueId: AdmissionsOverviewPageViewId.Overview,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Overview',
				hideText: 'never',
			},
			customSort: '1-Overview-1'
		},

	];
	constructor() {
		super(AdmissionsOverviewService._viewDroplistItems, AdmissionsOverviewService.name, AdmissionsOverviewPageTabId.Overview, AdmissionsOverviewPageViewId.Overview);
	}

	public get viewId() {
		return AdmissionsOverviewPageViewId;
	}

}